import React from 'react'
import {Route, Switch} from 'react-router-dom'

import {useSelector} from 'react-redux'
import {permissions} from '../../../../_constants/permissions'
import {hasPermission} from '../../../../_helper/hasPermission'
import {RouteWithPermission} from '../../../../_helper/routesWithPermission'
import {Error404} from '../../../modules/errors/components/Error404'
import {EditNotes} from '../../../pages/Notes/Nurses_Notes/edit/edit'
import {ListNotes} from '../../../pages/Notes/Nurses_Notes/List'
import {NewNotes} from '../../../pages/Notes/Nurses_Notes/new/New'
import NursesAsessmentList from '../../../pages/Notes/Nurses_Notes/Assessment/List'
import NewNursesAssessmentNote from '../../../pages/Notes/Nurses_Notes/Assessment/New'
import EditNursesAssessmentNote from '../../../pages/Notes/Nurses_Notes/Assessment/Edit'

export const NursesNotesIndexRoutes: React.FC = () => {
  const auth = useSelector((state: {auth: any}) => state.auth)
  const userPermissions = auth.user.roleId
  const canUpdate = hasPermission(userPermissions, permissions.notes_nurses_note_update)
  const canCreate = hasPermission(userPermissions, permissions.notes_nurses_note_update)
  const canRead = hasPermission(userPermissions, permissions.notes_nurses_note_view)
  const canUpdateEntry = hasPermission(userPermissions, permissions.notes_nurses_note_entry_update)
  const canCreateEntry = hasPermission(userPermissions, permissions.notes_nurses_note_entry_update)
  const canReadEntry = hasPermission(userPermissions, permissions.notes_nurses_note_entry_view)

  return (
    <>
      <Switch>
        
        <RouteWithPermission
          path='/notes/nurses-notes/edit/:id'
          component={EditNursesAssessmentNote}
          hasPerm={canUpdate}
        />
        <RouteWithPermission
          path='/notes/nurses-notes/new'
          component={NewNursesAssessmentNote}
          hasPerm={canCreate}
        />
        <RouteWithPermission
          path='/notes/nurses-notes/list'
          component={NursesAsessmentList}
          hasPerm={canRead}
        />
        <RouteWithPermission
          path='/notes/nurses-notes/entry/new'
          component={NewNotes}
          hasPerm={canCreateEntry}
        />
        <RouteWithPermission
          path='/notes/nurses-notes/entry/edit/:id'
          component={EditNotes}
          hasPerm={canUpdateEntry}
        />
        <RouteWithPermission
          path='/notes/nurses-notes/entry/:id'
          component={ListNotes}
          hasPerm={canReadEntry}
        />
        <RouteWithPermission
          path='/notes/nurses-notes/entry/list'
          component={ListNotes}
          hasPerm={canReadEntry}
        />
        <Route path='/error/404' component={Error404} />
      </Switch>
    </>
  )
}
